import cloneDeep from 'lodash/cloneDeep';
import { SavedView } from '@/app/modules/saved-views/types';
import { MetricsGridConfig } from '../core';
import {
  SavedViewDeserializer,
  SavedViewDeserializerResponse,
} from '@/app/modules/saved-views/types';

export const savedViewDeserializer: SavedViewDeserializer<MetricsGridConfig> = (
  config: MetricsGridConfig,
  view: SavedView
) => {
  console.log(
    'customers.component.savedViewReducer  called with\n',
    config,
    '\nand view\n',
    view.columns
  );
  const newConfig = cloneDeep(config);
  newConfig.groups.forEach((group, index) => {
    if (index === 0) {
      // Update visibility
      group.columns.forEach((col, index) => {
        group.columns[index].visible = view.columns.includes(col.title);
      });
    } else {
      group.visible = view.columns.includes(group.columnSelectorTitle);
    }
  });

  const response: SavedViewDeserializerResponse<MetricsGridConfig> = {
    config: newConfig,
    sorting: {
      key: view.sort.length > 0 ? view.sort[0].key : null,
      direction: view.sort.length > 0 ? view.sort[0].direction : null,
    },
  };

  return Promise.resolve(response);
};

export const categoriesSavedViewDeserializer: SavedViewDeserializer<
  MetricsGridConfig
> = (config: MetricsGridConfig, view: SavedView) => {
  console.log(
    'customers.component.savedViewReducer  called with\n',
    config,
    '\nand view\n',
    view.columns
  );
  const newConfig = cloneDeep(config);
  newConfig.groups.forEach((group, index) => {
    if (index === 0) {
      // Update visibility
      group.columns.forEach((col, index) => {
        group.columns[index].visible = view.columns.includes(col.title);
      });

      // Reorganize columns based on view.columns order
      group.columns.sort((a, b) => {
        const indexA = view.columns.indexOf(a.title);
        const indexB = view.columns.indexOf(b.title);

        // If both columns are in view.columns, sort by their position
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        // If only one is in view.columns, prioritize it
        if (indexA !== -1) {
          return -1;
        }
        if (indexB !== -1) {
          return 1;
        }

        // If neither is in view.columns, maintain original order
        return 0;
      });
    } else {
      group.visible = view.columns.includes(group.columnSelectorTitle);
    }
  });

  const response: SavedViewDeserializerResponse<MetricsGridConfig> = {
    config: newConfig,
    sorting: {
      key: view.sort.length > 0 ? view.sort[0].key : null,
      direction: view.sort.length > 0 ? view.sort[0].direction : null,
    },
  };

  return Promise.resolve(response);
};
